import { utils, Contract } from 'ethers';

/* Autogenerated file. Do not edit manually. */
var _abi = [{
  constant: false,
  inputs: [{
    name: "_token",
    type: "address"
  }],
  name: "release",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "WEEKS_IN_SECONDS",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "_token",
    type: "address"
  }],
  name: "vestedAmount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "_token",
    type: "address"
  }],
  name: "releaseableAmount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_token",
    type: "address"
  }, {
    name: "_vestingBeneficiary",
    type: "address"
  }, {
    name: "_vestingPeriodInWeeks",
    type: "uint256"
  }],
  name: "addToken",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getOwner",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "owner",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "data",
    type: "bytes"
  }],
  name: "parseAddr",
  outputs: [{
    name: "parsed",
    type: "address"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "vestingInfo",
  outputs: [{
    name: "vestingBeneficiary",
    type: "address"
  }, {
    name: "releasedSupply",
    type: "uint256"
  }, {
    name: "start",
    type: "uint256"
  }, {
    name: "duration",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "_token",
    type: "address"
  }],
  name: "getVestingInfo",
  outputs: [{
    components: [{
      name: "vestingBeneficiary",
      type: "address"
    }, {
      name: "releasedSupply",
      type: "uint256"
    }, {
      name: "start",
      type: "uint256"
    }, {
      name: "duration",
      type: "uint256"
    }],
    name: "",
    type: "tuple"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "token",
    type: "address"
  }, {
    indexed: false,
    name: "vestingBeneficiary",
    type: "address"
  }, {
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "Released",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "token",
    type: "address"
  }, {
    indexed: false,
    name: "vestingBeneficiary",
    type: "address"
  }, {
    indexed: false,
    name: "vestingPeriodInWeeks",
    type: "uint256"
  }],
  name: "LogTokenAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}];
var TokenVesting__factory = /** @class */function () {
  function TokenVesting__factory() {}
  TokenVesting__factory.createInterface = function () {
    return new utils.Interface(_abi);
  };
  TokenVesting__factory.connect = function (address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  };
  TokenVesting__factory.abi = _abi;
  return TokenVesting__factory;
}();

export { TokenVesting__factory };
